import { Callout, Container, Flex, Heading, Tabs } from '@radix-ui/themes'
import { CircleBackslashIcon } from '@radix-ui/react-icons'

import { MarginReportScreen } from '../components/MarginReport'
import { SalesReport } from '../components/SalesReport'
import { StockReport } from '../components/StockReport'
import { AdvancedReports } from '../components/AdvancedReports'

import { UserProfileRole } from '@/modules/users/types/UserProfile'
import { useAuth } from '@/hooks/useAuth'

export const ReportsScreen = () => {
  const { hasRole, userData } = useAuth()

  const ALLOWED_EMAILS = ['jpherrera@veekls.com', 'ashu@veekls.com']

  const isJphDemo =
    userData?.user?.email &&
    ALLOWED_EMAILS.includes(userData.user.email) &&
    userData?.organization?.name.toLowerCase().includes('demo')

  const hasAdvancedAccess = hasRole(UserProfileRole.AdvancedDealershipReports) || isJphDemo
  const hasAccess = hasRole(UserProfileRole.DealershipReports) || hasAdvancedAccess

  if (!hasAccess) {
    return (
      <Container p="4">
        <Callout.Root color="red">
          <Callout.Icon>
            <CircleBackslashIcon />
          </Callout.Icon>
          <Callout.Text>No tienes permisos para ver los reportes.</Callout.Text>
        </Callout.Root>
      </Container>
    )
  }

  return (
    <Flex direction="column" gap="2" width="100%" overflow="auto">
      <Heading>Reportes</Heading>

      <Tabs.Root defaultValue={hasAdvancedAccess ? 'advanced' : 'stock'}>
        <Tabs.List>
          {hasAdvancedAccess && <Tabs.Trigger value="advanced">Exportación Avanzada</Tabs.Trigger>}
          {hasRole(UserProfileRole.DealershipStockReport) && <Tabs.Trigger value="stock">Stock</Tabs.Trigger>}
          <Tabs.Trigger value="sales">Ventas</Tabs.Trigger>
          <Tabs.Trigger value="margin">Margen</Tabs.Trigger>
        </Tabs.List>
        {hasAdvancedAccess && (
          <Tabs.Content value="advanced">
            <AdvancedReports />
          </Tabs.Content>
        )}

        <Tabs.Content value="stock">
          <StockReport />
        </Tabs.Content>

        <Tabs.Content value="sales">
          <SalesReport />
        </Tabs.Content>

        <Tabs.Content value="margin">
          <MarginReportScreen />
        </Tabs.Content>
      </Tabs.Root>
    </Flex>
  )
}
